"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.option = void 0;
const option = (k, o) => o ? o[k] : undefined;
exports.option = option;
